// extracted by mini-css-extract-plugin
export default {"formBlock":"cert_formBlock__OD4Ad","formInputBlock":"cert_formInputBlock__M0hUk","formInput":"cert_formInput__TFc2X"};